export default "__VITE_ASSET__DbC22kOw__"